import { useTranslation } from "react-i18next";
import { FullDivider } from "./SubPage";

export function Impressum() {
  const { t } = useTranslation("impressum");
  const blocks = [
    { h: t("sec1Heading"), b: t("sec1Body") },
    { h: t("sec2Heading"), b: t("sec2Body") },
    { h: t("sec3Heading"), b: t("sec3Body") },
    { h: t("sec4Heading"), b: t("sec4Body") },
    { h: t("sec5Heading"), b: t("sec5Body") },
    { h: t("sec6Heading"), b: t("sec6Body") },
    { h: t("sec7Heading"), b: t("sec7Body") },
  ];

  return (
    <div className="pt-14 bg-grey-975">
      <div className="px-5 sm:px-8 md:px-[66px] py-16 md:py-24">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white tracking-tight mb-6 max-w-2xl leading-none">
          {t("title")}
        </h1>
      </div>
      <FullDivider />

      <div className="px-5 sm:px-8 md:px-[66px] py-10 md:py-14 space-y-10">
        {blocks.map((b) => (
          <div key={b.h}>
            <h2 className="text-[15px] font-medium text-white mb-3">{b.h}</h2>
            <p className="text-[13px] text-grey-400 leading-[1.75] whitespace-pre-line">{b.b}</p>
          </div>
        ))}
      </div>
      <FullDivider />
    </div>
  );
}
